import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CardBotaoParametroComponent } from './card-botao-parametro/card-botao-parametro.component';
import { CardAdComponent } from './card-ad/card-ad.component';
import { CardWebhookComponent } from './card-webhook/card-webhook.component';
import { CardTokenComponent } from './card-token/card-token.component';
import { CardAwsSesComponent } from './card-aws-ses/card-aws-ses.component';
import { CardPlataformaComponent } from './card-plataforma/card-plataforma.component';
import { CardIntegracaoComponent } from './card-integracao/card-integracao.component';
import { MatIcon } from "@angular/material/icon";
import { CardIntegraXSmsComponent } from './card-integrax-sms/card-integrax-sms.component';
import { CardAzureAcsComponent } from './card-azure-acs/card-azure-acs.component';
import { CardWhatsappComponent } from './card-whatsapp/card-whatsapp.component';

@Component({
  selector: 'app-parametros',
  standalone: true,
  imports: [
    CardBotaoParametroComponent,
    CardAdComponent,
    CardWebhookComponent,
    CardTokenComponent,
    CardAwsSesComponent,
    CardPlataformaComponent,
    CardIntegracaoComponent,
    CardIntegraXSmsComponent,
    CardAzureAcsComponent,
    CardWhatsappComponent,
    MatIcon
],
  templateUrl: './parametros.component.html',
  styleUrl: './parametros.component.css'
})
export class ParametrosComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);

  abaAtiva = 'ad';

  private readonly descricoes: Record<string, string> = {
    integracao: 'Permite configurar integrações com sistemas externos para atualizar a timeline dos contatos durante eventos realizados na plataforma, como disparos de e-mails. É possível definir um payload com informações variáveis do contato para envio e atualização automática.',
    ad: 'Habilita a autenticação de usuários por meio das contas Microsoft corporativas, centralizando o acesso e o gerenciamento de permissões.',
    webhook: 'Configure uma URL para receber eventos de atualização de contatos, permitindo a sincronização automática de informações entre sistemas.',
    token: 'Token de autenticação do ClariTalk utilizado para permitir que plataformas externas consumam seus recursos e realizem integrações de forma segura.',
    plataforma: 'Configure as plataformas autorizadas a consultar bases dinâmicas e as regras de montagem associadas a elas.',
    awsSes: 'Configura a conexão com o serviço de envio de e-mails da AWS, permitindo o disparo de mensagens por meio da plataforma.',
    integrax: 'Configura o envio de SMS pela IntegraX, incluindo token, remetente aprovado, valor por mensagem e acesso à API de envio.',
    azureAcs: 'Configura a conexão com o serviço de envio de e-mails da Azure Communication Services, incluindo limites de envio mensal, diário e por hora.',
    whatsapp: 'Cadastre e edite os valores de custo estimado por mensagem WhatsApp, por país e categoria de cobrança (Marketing, Utilidade, Autenticação, Serviço).'
  };

  ngOnInit(): void {
    const aba = this.route.snapshot.queryParamMap.get('aba');
    if (aba) {
      this.abaAtiva = aba;
    }
  }

  selecionarAba(aba: string) {
    this.abaAtiva = aba;
  }

  get descricaoAba(): string {
    return this.descricoes[this.abaAtiva] ?? '';
  }
}
